import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@ca/environment/environment';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { APEER_BLOB_STORAGE_URL_PART, ARIVIS_VIEWER_API_SERVICE_URL } from '../../shared/constants/constants';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Skip Azure. Auth header will cause error when getting file.
        if (req && req.url.includes(APEER_BLOB_STORAGE_URL_PART)) {
            return next.handle(req);
        }

        let headers: HttpHeaders = req.headers;

        if (this.authService.hasValidAccessToken()) {
            const token = this.authService.accessToken;
            headers = headers.set('Authorization', `Bearer ${token}`);

            if (req.url.includes(ARIVIS_VIEWER_API_SERVICE_URL)) {
                headers = headers.set('Apeer-authorization', `${token}`);
            }
        }

        const authReq = req.clone({ headers });

        return next.handle(authReq).pipe(
            catchError((error: unknown) => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    this.authService.handleNonAuthorizedRoutesOrRequests();
                }
                return observableThrowError(error);
            }),
            timeout(environment.requestTimeout),
        );
    }
}
